export type PromoBonusType = "AllYouCanSpeak" | "ExtraLessons" | "ExtraWeeks";

export type UserClassRoomPromoBonusDto = {
  type: PromoBonusType;
  promoIds: string[];
  planId: string;
  lessonsCountedPerWeek: number | null;
  activeFromUtc: string | null;
  activeToUtc: string | null;
};

export type UserClassRoomFeedbackDto = {
  id: string;
  teacherId: string;
  notes: string;
  noShow: boolean;
  participation: number;
  targetLanguage: number;
  differentSpeakingLevelSuggested: string | null;
};

export type UserClassRoomReviewDto = {
  reviewedAtUtc: string;
  reviewNotes: string;
  generalLessonScore: number;
  teacherClearanceScore: number;
  teacherInvolvementScore: number;
  teacherComfortableScore: number;
  topicUsefulnessScore: number;
  topicDifficultyScore: number;
};

export type UserClassRoomProgressCheckResultDto = {
  teacherId: string;
  passed: boolean;
  noShow: boolean;
  comprehension: number;
  vocabularyRange: number;
  fluency: number;
  accuracy: number;
  recommendation: string[];
  notes: string;
  toLevel: string | null;
};

export type UserClassRoomHistoryItemDto = {
  classRoomId: string;
  startUtc: string;
  endUtc: string;
  classRoomTimezone: string;
  teacherId: string;
  teacherGivenName: string | null;
  teacherFamilyName: string | null;
  teacherEmail: string | null;
  is1on1: boolean;
  userGroupId: string;
  userGroupName: string | null;
  classRoomType: string;
  isProgressCheck: boolean;
  speakingLevel: string;
  topicName: string | null;
  capacity: number;
  participantsCount: number;
  attendedParticipantsCount: number;
  noShowParticipantsCount: number;
  feedbackCount: number;
  userNoShow: boolean;
  giftedByPromo: boolean;
  promoBonus: UserClassRoomPromoBonusDto | null;
  userFeedback: UserClassRoomFeedbackDto | null;
  userReview: UserClassRoomReviewDto | null;
  progressCheckResult: UserClassRoomProgressCheckResultDto | null;
};

const promoBonusLabels: Record<PromoBonusType, string> = {
  AllYouCanSpeak: "All You Can Speak",
  ExtraLessons: "Extra lessons",
  ExtraWeeks: "Extra weeks",
};

export function getPromoBonusLabel(type: PromoBonusType | string): string {
  return promoBonusLabels[type as PromoBonusType] ?? type;
}
